import { hydrate } from "./hydration.js";
const scalarScript = { hydrate };
export {
  scalarScript
};
//# sourceMappingURL=index.js.map
